import { render, staticRenderFns } from "./InputVials.mobile.vue?vue&type=template&id=b34ba986&scoped=true&"
import script from "./InputVials.mobile.vue?vue&type=script&lang=js&"
export * from "./InputVials.mobile.vue?vue&type=script&lang=js&"
import style0 from "./InputVials.mobile.vue?vue&type=style&index=0&id=b34ba986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34ba986",
  null
  
)

export default component.exports